import { useGetFeatureFlagsQuery } from "services/common/featureFlagService";
import MyLoansV2 from "pages/my-loans-v2/MyLoansV2";
import LoansList from "./loans-list/LoansList";

export default function MyLoans() {
  const { data: featureFlags } = useGetFeatureFlagsQuery();

  return (
      featureFlags?.myLoansV2Enabled ? <MyLoansV2 /> : <LoansList />
  );
}
